import React, { useState, useEffect } from 'react'

/**
 * Smart App Banner for Android devices
 * iOS uses the native meta tag in index.html
 *
 * To update the Play Store URL, change PLAY_STORE_URL below
 */

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.curayt.neighbortopia'

const SmartAppBanner = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [isAndroid, setIsAndroid] = useState(false)

  useEffect(() => {
    // Check if device is Android
    const userAgent = navigator.userAgent.toLowerCase()
    const isAndroidDevice = /android/i.test(userAgent)

    // Don't show if already in a webview/app
    const isInApp = /wv|webview/i.test(userAgent)

    if (isAndroidDevice && !isInApp) {
      setIsAndroid(true)
      setIsVisible(true)
    }
  }, [])

  const handleClose = () => {
    setIsVisible(false)
  }

  const handleOpenApp = () => {
    window.open(PLAY_STORE_URL, '_blank')
  }

  if (!isAndroid || !isVisible) {
    return null
  }

  return (
    <div style={styles.banner}>
      <button style={styles.closeButton} onClick={handleClose} aria-label="Close">
        ✕
      </button>
      <div style={styles.iconContainer}>
        <img
          src="/logo.jpeg"
          alt="NeighborTopia"
          style={styles.icon}
        />
      </div>
      <div style={styles.textContainer}>
        <div style={styles.title}>NeighborTopia</div>
        <div style={styles.subtitle}>Get the Android app</div>
      </div>
      <button style={styles.viewButton} onClick={handleOpenApp}>
        VIEW
      </button>
    </div>
  )
}

const styles = {
  banner: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '76px',
    backgroundColor: '#f2f2f2',
    borderBottom: '1px solid #c8c8c8',
    display: 'flex',
    alignItems: 'center',
    padding: '0 12px',
    zIndex: 9999,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '18px',
    color: '#888',
    cursor: 'pointer',
    padding: '8px',
    marginRight: '4px',
  },
  iconContainer: {
    width: '52px',
    height: '52px',
    borderRadius: '10px',
    overflow: 'hidden',
    flexShrink: 0,
  },
  icon: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  textContainer: {
    flex: 1,
    marginLeft: '12px',
    overflow: 'hidden',
  },
  title: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#333',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  subtitle: {
    fontSize: '12px',
    color: '#666',
    marginTop: '2px',
  },
  viewButton: {
    backgroundColor: '#7CB65F',
    color: 'white',
    border: 'none',
    borderRadius: '16px',
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    marginLeft: '12px',
    flexShrink: 0,
  },
}

export default SmartAppBanner
